var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.59,
    height: 19.59,
    viewBox: "0 0 19.59 19.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#212121;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.774-11.6,19.39,5a1.4,1.4,0,0,0,.669.376,1.543,1.543,0,0,0,1.446-.389,1.434,1.434,0,0,0,.389-.688,1.6,1.6,0,0,0,0-.777,1.4,1.4,0,0,0-.376-.663l-16.6-16.6a1.356,1.356,0,0,0-.663-.37,1.716,1.716,0,0,0-.777,0,1.389,1.389,0,0,0-.688.382,1.483,1.483,0,0,0-.376.682,1.6,1.6,0,0,0,0,.777A1.453,1.453,0,0,0,2.774-11.6Zm0,14.475a1.417,1.417,0,0,0-.37.656,1.579,1.579,0,0,0-.006.784,1.358,1.358,0,0,0,.389.675,1.434,1.434,0,0,0,.688.389,1.6,1.6,0,0,0,.777,0A1.4,1.4,0,0,0,4.915,5l16.6-16.6a1.4,1.4,0,0,0,.376-.669,1.6,1.6,0,0,0,0-.777,1.434,1.434,0,0,0-.389-.682,1.535,1.535,0,0,0-.682-.382,1.53,1.53,0,0,0-.771-.006,1.4,1.4,0,0,0-.663.376Z",
    transform: "translate(-2.352 14.161)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross_black.7278a1fc9602ab6376bc300b5af280c3.svg";
export { ForwardRef as ReactComponent };